import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import ImportProductsModal from "./ImportProductsModal";
import ComboPackModal from "./ComboModal"; // ✅ new modal

const ProductToolbar = ({
  searchQuery,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedStatus,
  onStatusChange,
  sortBy,
  onSortChange,
  onAddProduct,
  onBulkActions,
  selectedProducts,
  totalProducts,
}) => {
  const [isImportOpen, setIsImportOpen] = useState(false);
  const [isComboOpen, setIsComboOpen] = useState(false); // ✅ Combo Modal state

  const categoryOptions = [
    { value: "all", label: "All Categories" },
    { value: "product", label: "Product" },
    { value: "service", label: "Service" },
  ];

  const statusOptions = [
    { value: "all", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const sortOptions = [
    { value: "name_asc", label: "Name (A-Z)" },
    { value: "name_desc", label: "Name (Z-A)" },
    { value: "price_asc", label: "Price (Low to High)" },
    { value: "price_desc", label: "Price (High to Low)" },
    { value: "date_desc", label: "Newest First" },
    { value: "date_asc", label: "Oldest First" },
    { value: "inventory_asc", label: "Low Stock First" },
    { value: "inventory_desc", label: "High Stock First" },
  ];

  const bulkActionOptions = [
    { value: "activate", label: "Activate Selected" },
    { value: "deactivate", label: "Deactivate Selected" },
    { value: "update_price", label: "Update Prices" },
    { value: "update_inventory", label: "Update Inventory" },
    { value: "export", label: "Export Selected" },
    { value: "archive", label: "Archive Selected" },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Top Row */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="Search products by name, category, or SKU..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full"
          />
        </div>

        <div className="flex items-center space-x-3">
          <Button
            variant="default"
            onClick={onAddProduct}
            iconName="Plus"
            iconPosition="left"
            iconSize={16}
            className="whitespace-nowrap"
          >
            Add New Product
          </Button>

          {/* ✅ New Combo Pack Button */}
          <Button
            variant="outline"
            iconName="PackagePlus"
            iconPosition="left"
            iconSize={16}
            className="whitespace-nowrap"
            onClick={() => setIsComboOpen(true)}
          >
            Create Combo Pack
          </Button>

          {/* Import Products Button */}
          <Button
            variant="outline"
            iconName="Upload"
            iconPosition="left"
            iconSize={16}
            className="whitespace-nowrap"
            onClick={() => setIsImportOpen(true)}
          >
            Import Products
          </Button>
        </div>
      </div>

      {/* Bottom Row */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          <Select
            options={categoryOptions}
            value={selectedCategory}
            onChange={onCategoryChange}
            placeholder="Category"
            className="min-w-[150px]"
          />

          <Select
            options={statusOptions}
            value={selectedStatus}
            onChange={onStatusChange}
            placeholder="Status"
            className="min-w-[130px]"
          />

          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Sort by"
            className="min-w-[160px]"
          />
        </div>

        <div className="flex items-center space-x-4">
          {selectedProducts?.length > 0 && (
            <div className="flex items-center space-x-2">
              <span className="text-sm text-muted-foreground">
                {selectedProducts.length} selected
              </span>
              <Select
                options={bulkActionOptions}
                value=""
                onChange={onBulkActions}
                placeholder="Bulk Actions"
                className="min-w-[140px]"
              />
            </div>
          )}

          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Package" size={16} />
            <span>{totalProducts} products</span>
          </div>
        </div>
      </div>

      {/* Modals */}
      <ImportProductsModal
        isOpen={isImportOpen}
        onClose={() => setIsImportOpen(false)}
      />

      <ComboPackModal
        isOpen={isComboOpen}
        onClose={() => setIsComboOpen(false)}
      />
    </div>
  );
};

export default ProductToolbar;
